import videojs from 'video.js';
import flvjs from "../../thirdparty/flv/flv";
import { cloneDeep } from "lodash";
import Fmp4Player from './fmp4Player';

const Html5 = videojs.getTech('Html5');
const mergeOptions = videojs.mergeOptions || videojs.util.mergeOptions;
const defaults = {
  mediaDataSource: {},
  config: {}
};

class WSFmp4 extends Html5 {

  // 初始化
  constructor(options, ready) {
    options = mergeOptions(defaults, options);
    super(options, ready);
  }

  //流切换
  setSrc(src) {
    if (this.fmp4Player) {
      this.fmp4Player.detachMediaElement();
    }

    const mediaDataSource = cloneDeep(this.options_.mediaDataSource);
    const config = cloneDeep(this.options_.config);
    // mediaDataSource.type = mediaDataSource.type === undefined ? 'flv' : mediaDataSource.type;
    mediaDataSource.url = src;
    this.fmp4Player = new Fmp4Player(mediaDataSource, config);
    this.fmp4Player.attachMediaElement(this.el_);
  }

  /**
   * 销毁
   */
  dispose() {
    if (this.fmp4Player) {
      this.fmp4Player.detachMediaElement();
    }
    super.dispose();
  }

}

// 是否支持flv
WSFmp4.isSupported = function () {
  return flvjs.isSupported();
};

// 支持类型
WSFmp4.formats = {
  'video/fmp4': 'FMP4',
};

// 支持类型
WSFmp4.canPlayType = function (type) {
  if (WSFmp4.isSupported() && type in WSFmp4.formats) {
    return 'maybe';
  }

  return '';
};

// VideoJS 拦截
WSFmp4.canPlaySource = function (srcObj, options) {
  return WSFmp4.canPlayType(srcObj.type);
};

WSFmp4.VERSION = '__VERSION__';

videojs.registerTech('WSFmp4', WSFmp4);

export default WSFmp4;